import { render, staticRenderFns } from "./OrderEditor.vue?vue&type=template&id=246ea6e3&"
import script from "./OrderEditor.vue?vue&type=script&lang=js&"
export * from "./OrderEditor.vue?vue&type=script&lang=js&"
import style0 from "./OrderEditor.vue?vue&type=style&index=0&id=246ea6e3&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports